import { Elements, StripeProvider } from "react-stripe-elements";
import PrimoInfo from "../PrimoSubscriptionModal/PrimoInfo";
import PrimoCheckoutForm from "../PrimoSubscriptionModal/PrimoCheckoutForm";
import { useSelector } from "react-redux";

export default function PrimoSubscription({
  showDistributionModul = false,
  albumId = null,
  setDistributeAlbumSuccess = null,
  setDistributeAlbumError = null,
  handleClose = null,
  onCheckoutDone = null,
}) {
  const { current_user } = useSelector(({ current_user }) => ({
    current_user,
  }));
  return (
    <div className="primo">
      {showDistributionModul ? (
        <PrimoInfo
          handleClose={handleClose}
          albumId={albumId}
          setDistributeAlbumSuccess={setDistributeAlbumSuccess}
          setDistributeAlbumError={setDistributeAlbumError}
        />
      ) : (
        <StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}>
          <Elements>
            <PrimoCheckoutForm current_user={current_user} onCheckoutDone={onCheckoutDone} />
          </Elements>
        </StripeProvider>
      )}
    </div>
  );
}
